import { Box } from '@zillow/constellation-10';
import { PostsLayout } from '@zillow/zrs-cms';
import type { PostCardProps } from '@zillow/zrs-cms';
import React from 'react';

interface Category {
    name: string;
    link?: string;
}

interface FeaturedImage {
    sourceUrl?: string;
    altText?: string;
    alt_text?: string;
    medium?: {
        width: number;
        height: number;
        sourceUrl: string;
    };
    mediaDetails?: {
        width?: number;
        height?: number;
    };
}

interface RelatedPost {
    id: number;
    link: string;
    title?: { raw?: string };
    excerpt?: { raw?: string };
    primaryCategory?: Category | null;
    categories?: Category[];
    featuredImage?: FeaturedImage | null;
}

interface RelatedPostsProps {
    post?: {
        id: number;
        relatedPosts?: RelatedPost[] | null;
    };
}

const RelatedPosts = ({ post }: RelatedPostsProps) => {
    if (!post?.relatedPosts) {
        return null;
    }

    const isThisPost = (aPost: RelatedPost) => aPost.id === post.id;
    const relatedPosts = post.relatedPosts
        .filter((relatedPost) => !isThisPost(relatedPost))
        .slice(0, 3);
    if (relatedPosts.length === 0) {
        return null;
    }

    return (
        <Box
            css={{
                backgroundColor: 'bg.accent.brand.hero',
                paddingBlock: 'looser',
                paddingInline: 'default',
                marginBottom: 'loose',
                md: {
                    paddingBlock: 'layout.looser',
                    borderRadius: '600',
                },
                xl: {
                    paddingBlock: 'layout.vast.default',
                    paddingInline: 'layout.looser',
                    marginBottom: 'layout.looser',
                },
            }}
        >
            <Box
                asChild
                css={{
                    textStyle: {
                        base: 'heading-xs',
                        md: 'heading-sm',
                        xl: 'heading-md',
                    },
                    color: 'white',
                    marginBottom: { base: 'loose', md: 'looser' },
                }}
            >
                <p>Related Articles</p>
            </Box>

            <PostsLayout
                layout="INLINE"
                items={
                    relatedPosts.map((relatedPost) => ({
                        id: relatedPost.id,
                        title: relatedPost.title?.raw ?? '',
                        url: { href: relatedPost.link },
                        excerpt: relatedPost.excerpt?.raw,
                        alignment: 'vertical',
                        size: 'md',
                        category:
                            relatedPost.primaryCategory ||
                            relatedPost.categories?.[0],
                        forceHideReadTime: true,
                        forceShowCategory: true,
                        image: relatedPost.featuredImage || undefined,
                    })) as PostCardProps[]
                }
            />
        </Box>
    );
};

export default RelatedPosts;
